let logInfo = localStorage.getItem('jyb_logInfo') ? JSON.parse(localStorage.getItem('jyb_logInfo')) : {};
let token = localStorage.getItem('jyb_token') || '';

const state = {
   logInfo,
   token,
   keyword: ''
};

export default state;